import { ReactNode } from 'react';
import { Box, Container, Paper, Stack, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

interface PageScaffoldProps {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl';
  contentSx?: SxProps<Theme>;
}

export default function PageScaffold({
  title,
  subtitle,
  actions,
  children,
  maxWidth = 'lg',
  contentSx,
}: PageScaffoldProps) {
  return (
    <Box sx={{ width: '100%', minHeight: 'calc(100vh - 64px)', py: { xs: 2, md: 3 } }}>
      <Container maxWidth={maxWidth}>
        <Paper
          variant="outlined"
          sx={{
            p: { xs: 2, md: 3 },
            borderRadius: 1,
            bgcolor: '#fff',
            ...contentSx,
          }}
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems={{ xs: 'stretch', sm: 'center' }}
            justifyContent="space-between"
            spacing={2}
            sx={{ mb: 2 }}
          >
            <Box>
              <Typography variant="h5" component="h1" sx={{ fontWeight: 700, color: '#330662' }}>
                {title}
              </Typography>
              {subtitle && (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
                  {subtitle}
                </Typography>
              )}
            </Box>
            {actions}
          </Stack>
          {children}
        </Paper>
      </Container>
    </Box>
  );
}
